import React, { useState } from 'react';
import Table from 'UI/Table';
import PopupForm from 'UI/PopupForm';
import Filters from 'Features/Filters';
import { find } from 'lodash';
import { filteredVcenterAssets } from './Data';


const vCentersTable = ({ data, editableFields, url, modelName }) => {
  const [filters, changeFilters] = useState({
    client: 'All',
    datacentre: 'All',
    status: [{ label: 'current', value: 'current' }]
  })
  const columns = [
    {
      Header: '',
      maxWidth: 80,
      style: { textAlign: 'center' },
      filterable: false,
      Cell: (row) => (
        <PopupForm
          fieldNames={editableFields}
          url={`${url}/${row.original.id}`}
          modelName={modelName}
          actionType='Edit'
          formableObject={row.original}
        />
      ),
    },
    { Header: 'Name', accessor: 'name', type: 'link_blank' },
    { Header: 'Customer', accessor: 'customer_name', type: 'clientNameWithStatus' },
    { Header: 'Clusters', accessor: 'cluster_count', width: 120 },
    { Header: 'Hosts', accessor: 'host_count', width: 120 },
    { Header: 'VMs', accessor: 'vm_count', width: 120 },
    { Header: 'FQDN', accessor: 'fqdn' },
    { Header: 'Datacentre', accessor: 'datacentre' },
  ]
  const statusOptions = find(editableFields, field => field.value == 'lifecycle_status').selectOptions
  const clientOptions = find(editableFields, field => field.value == 'viaje_client_id').selectOptions
  const datacentreOptions = find(editableFields, field => field.value == 'site_code').selectOptions

  return (
    <div>
      <Filters filters={filters} onChange={changeFilters} className='mt-3'>
        <Filters.Select filterName='status' label='Status' options={statusOptions} />
        <Filters.Select filterName='client' label='Customer' options={clientOptions} />
        <Filters.Select filterName='datacentre' label='Datacentre' options={datacentreOptions} />

      </Filters>
      <Table
        data={filteredVcenterAssets(filters, data)}
        columns={columns}
        filterable
      />
    </div>
  )
}

export default vCentersTable
